import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { HomeEssentials, InfoBox, InfoPanel, Loading, TextBox, UnitAmenities, UnitPanel } from '../../components';
import { useTripStoreUpdater } from '../../hooks';
import { TripState } from '../../types/trip.store.type';
import { StoreState } from '../../types/store.type';
import { IconHandshake } from '../../assets/icons';
import '../../styles/_in-the-home.scss';
import { TranslationUtils } from '../../utils';
import { BedRoomLayout } from '../../components/BedRoom/BedRoomLayout';
import _ from 'lodash';

export const InTheHome: React.FC = () => {
    useTripStoreUpdater(true);

    const trip: TripState = useSelector((store: StoreState) => store.trip);

    const { isLoading, access, home_info: homeInfo, unit } = trip;

    if (isLoading) {
        return <Loading />;
    }
    if (!access || !homeInfo || !unit) {
        return null;
    }

    const { is_masked, wifi } = access;

    const alertMessage = access.wifi_masked_note || access.masked_note || TranslationUtils.get('passwords_will_be_provided');
    const showBedRooms = !_.isNil(homeInfo.bedrooms_details) && !_.isEmpty(homeInfo.bedrooms_details);

    return (
        <div>
            <h1 tabIndex={0} className="heading-large page-title">
                {TranslationUtils.get('features_and_amenities')}
            </h1>

            <UnitPanel />

            <Row>
                <Col sm={6}>
                    {is_masked && wifi ? (
                        <InfoPanel title={TranslationUtils.get('internet_access')} alert={alertMessage}>
                            <InfoBox info={typeof wifi === 'string' ? wifi : '*****'} subtitle={TranslationUtils.get('network')} />
                            <InfoBox info={typeof wifi === 'string' ? wifi : '*****'} subtitle={TranslationUtils.get('password')} />
                        </InfoPanel>
                    ) : (
                        <React.Fragment>
                            {wifi && typeof wifi !== 'string' && wifi.wifi ? (
                                <InfoPanel title={TranslationUtils.get('internet_access')} alert={undefined}>
                                    <InfoBox info={wifi.wifi_network || ''} subtitle={TranslationUtils.get('network')} />
                                    <InfoBox info={wifi.wifi_password || ''} subtitle={TranslationUtils.get('password')} />
                                </InfoPanel>
                            ) : null}
                        </React.Fragment>
                    )}
                </Col>
            </Row>

            <div>
                <div className={'mb-5'} />
                {unit.misc_details && unit.important_info !== unit.misc_details && (
                    <div tabIndex={0}>
                        <p tabIndex={0} className="body-bold-l page-subtitle">
                            {TranslationUtils.get('note_for_our_guests')}
                        </p>
                        <div className={'mb-2'} />
                        <TextBox
                            classTitle={'body-bold page-subtitle'}
                            classNote={'body-regular page-text-notes'}
                            inline={true}
                            title=""
                            text={unit.misc_details}
                            maxLength={4000}
                        />
                        <div className={'mb-4'} />
                    </div>
                )}
            </div>
            <HomeEssentials />
            {showBedRooms && <BedRoomLayout />}
            <div className="house-rules">
                <div className="house-rules-title">
                    <div className="house-rules-icon">
                        <IconHandshake />
                    </div>
                    <span className={'body-small-bold'} tabIndex={0}>
                        {TranslationUtils.get('house_rules')}
                    </span>
                </div>
                <div className={'body-regular'} tabIndex={0} dangerouslySetInnerHTML={{ __html: homeInfo.house_rules }} />
            </div>

            <UnitAmenities />
        </div>
    );
};
